import React from "react";
import { Header } from "../../components/Header/Headers";
import AuditLogs from "./Components/AuditLogs";

const AuditLogsSection: React.FC = () => {
  return (
    <>
      <Header
        title="Audit Logs & Activity History"
        breadcrumb="Admin Console / Audit Logs"
      />
      <AuditLogs />
    </>
  );
};

export default AuditLogsSection;
